<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">FFC Partners</h2>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Create
          Content
        </span>
      </base-button>
    </div>
    <PartnersTable />
  </b-card>
</template>

<script>
import PartnersTable from "./components/PartnersTable.vue";

export default {
  components: {
    PartnersTable,
  },
  methods: {
    handleAdd() {
      this.$router.push("/admin/add-ffc-partner");
    },
  },
};
</script>
